import React from "react";

export const getMetabaseQuestionDownloadUrl = (src, format) => {
  if (!src) {
    return "";
  }

  const embedQuestionPath = "/embed/question/";
  const pathIndex = src.indexOf(embedQuestionPath);
  if (pathIndex === -1) {
    return "";
  }

  let parsedUrl = null;
  try {
    parsedUrl = new URL(src);
  } catch (error) {
    return "";
  }

  const tokenStart = pathIndex + embedQuestionPath.length;
  const tokenEnd = src
    .slice(tokenStart)
    .search(/[?#]/);
  const token =
    tokenEnd === -1
      ? src.slice(tokenStart)
      : src.slice(tokenStart, tokenStart + tokenEnd);

  const normalizedFormat = format === "csv" ? "csv" : "xlsx";

  return token
    ? `${parsedUrl.origin}/api/embed/card/${token}/query/${normalizedFormat}${parsedUrl.search}`
    : "";
};

function MetabaseFrame(props) {
  const {
    title,
    src,
    height = 420,
    allowFullScreen = true,
    loading = "lazy",
    isLoading = false,
    className = "",
    showDownloadButton = false,
    downloadLabel = "Download Results",
    downloadUrl = "",
  } = props;
  const resolvedDownloadUrl =
    downloadUrl || getMetabaseQuestionDownloadUrl(src);
  const canDownload = Boolean(resolvedDownloadUrl) && !isLoading;

  const handleDownload = () => {
    if (!canDownload) {
      return;
    }

    window.open(resolvedDownloadUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="bg-white border border-[#e5e7eb] rounded-md overflow-hidden">
      {/* <div className="px-4 py-3 border-b border-[#e5e7eb]">
        <h3 className="text-base font-semibold text-[#1f2937]">
          {title || "Metabase Frame"}
        </h3>
      </div> */}
      {showDownloadButton ? (
        <div className="px-6 py-4 flex justify-end border-b border-[#e5e7eb]">
          <button
            type="button"
            className={`btn text-xl border text-white ${
              canDownload ? "btn-red" : "cursor-not-allowed bg-[#e9e9ea]"
            }`}
            onClick={handleDownload}
            disabled={!canDownload}
          >
            {downloadLabel}
          </button>
        </div>
      ) : null}
      <div className="w-full">
        {isLoading ? (
          <div
            className="w-full flex items-center justify-center text-[#6b7280] text-sm"
            style={{ height: `${height}px` }}
          >
            Loading frame...
          </div>
        ) : src ? (
          <iframe
            title={title || "Metabase Frame"}
            src={src}
            className={"w-full border-0 " + (className || "")}
            style={{ height: `${height}px` }}
            loading={loading}
            allowFullScreen={allowFullScreen}
          />
        ) : (
          <div
            className="w-full flex items-center justify-center text-[#6b7280] text-sm"
            style={{ height: `${height}px` }}
          >
            Frame URL is missing
          </div>
        )}
      </div>
    </div>
  );
}

export default MetabaseFrame;
